import { RecurringSeriesOccurrence } from '@spike/new-booking-model';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { RECURRING_SERIES_OCCURRENCE_STATUS_LABELS } from 'model/RecurringSeries';
import styles from './RecurringSeriesView.module.scss';

interface SeriesBookingStatusPillProps {
    status: RecurringSeriesOccurrence['status'];
}

const STATUS_CLASSES: Record<RecurringSeriesOccurrence['status'], string> = {
    created: styles.statusBooked,
    draft: styles.statusDraft,
    needs_review: styles.statusNeedsReview,
    skipped: styles.statusSkipped,
    failed: styles.statusFailed,
    exception: styles.statusNeutral,
    protected: styles.statusProtected,
    protected_exception: styles.statusProtected,
    canceled: styles.statusCanceled,
    unknown: styles.statusNeutral
};

export const SeriesBookingStatusPill: FunctionComponent<SeriesBookingStatusPillProps> = props => (
    <span className={clsx(styles.statusPill, STATUS_CLASSES[props.status])}>
        {RECURRING_SERIES_OCCURRENCE_STATUS_LABELS[props.status]}
    </span>
);

export default SeriesBookingStatusPill;
